export { default } from "./DynamicSuccessPopUp";
export * from "./DynamicSuccessPopUp.types";
export * from "./DynamicSuccessPopUp.utils";
